import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AppCustomLink from '../Common/AppCustomLink';
// import Link from 'next/link';
// import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Img from 'react-image';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import PostItem from './PostItem';
// import AddPost from './AddPost';
import { addToPlaylist, deleteFromPlaylist, deleteFromHistory, deleteFromHistoryProgress, deleteReview, appInfo, regenerateChapImage } from '../../actions';

import { Button, Col, Drawer, Dropdown, Menu, Modal, Row, notification } from 'antd';
import {
  secToTime, cleanFirebaseId, getPodcastImgSize, sortAlphabeticallyName, convertToSlug,
  cleanText, isLocalStoragePresent, setCurrentEpisodeData, getUUID,
  podcastSlugUrl, podcastHrefUrl, setCurrentPodcastData, saveLocally, secToDateFromPubDate, cleanGenres, isMyReview, getFinalEpisodeImg,
  isAdmin,
  cleanTitleText
} from '../../lib/utils';
import { spacing, fixedSpacing, maxScreenSize, colors, rightSideBarColor } from '../../lib/theme';
import RatingModal from './RatingModal';
import PlayMain from '../Common/PlayMain';
import ExpandCollapse from '../ExpandCollapse';
import EpisodeProgressBar from './EpisodeProgressBar';
import PodcastEpisodeOptions from './PodcastEpisodeOptions';
import PodcastEpisodeImage from './PodcastEpisodeImage';
import { QUEUE } from '../../lib/strings';
import EpisodePage from '../Common/EpisodePage';
import ShowPopular from './ShowPopular';
import ProfilePageRoute from '../Common/ProfilePageRoute';
import { getIsPremiumUser } from '../../lib/fileUtils';
import EpisodeDrawer from '../Common/EpisodeDrawer';
import SignUp from '../Auth/SignUp';
import ChapterImage from '../Common/ChapterImage';
//List component which loads posts as they come in.

const { confirm } = Modal;
const SubMenu = Menu.SubMenu;
const nanooUID = 'V1FOpIGO3iNio1ZCZ7mmHXtyaqt1';

class PodcastEpisode extends React.Component {
  // class PodcastEpisode extends React.PureComponent { // testing PureComponent
  constructor(props) {
    super(props);
    this.state = { noImageLoadError: true, windowWidth: 1200, visibleDrawer: false, showAuth: false };
  }

  componentDidMount() {
    this.setState({ windowWidth: window.innerWidth });
  }

  // shouldComponentUpdate(nextProps) { // to do personal values when logged in.
  //   const { itunesImage } = this.props;
  //   if (nextProps.itunesImage !== itunesImage) { // when itunes data loaded to get the artworkUrl600 image
  //     return true;
  //   }

  //   // if (currentlyPlaying) {
  //   //   return true;
  //   // }
  //   // const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
  //   // if ((typeof nextProps !== 'undefined' && nextProps.personalValues[guidCleaned] !== personalValues[guidCleaned])) {
  //   //   return true;
  //   // }
  //   return false;
  // }

  saveEpisodeLocally(podcastEpisode) {
    console.dir('saveEpisodeLocally');
    const { isBasic } = this.props;
    if (isBasic) {
      saveLocally('basicEpisode', true, 0, true);
    }
    if (isLocalStoragePresent()) {
      localStorage.setItem('lastLocalEpisode', JSON.stringify(podcastEpisode));
    } else {
      setCurrentEpisodeData(podcastEpisode);
    }
    this.onDrawerOpen();
  }

  onDrawerClose = () => {
    this.setState({
      visibleDrawer: false,
    });
  };

  onDrawerOpen = () => {
    const appInfoLoc = appInfo;
    const { userDetails, podcastEpisode } = this.props;
    console.dir(appInfoLoc);
    if (!userDetails || !userDetails.uid) {
      // notification.info({
      //   // duration: 0,
      //   message: 'Please sign in or register to view the summary.',
      // });

      this.setState({
        showAuth: true,
      });
      return;
    }
    const isFreeBook = appInfoLoc.bookOfDay && appInfoLoc.bookOfDay.collectionId == podcastEpisode.collectionId;
    if (!isFreeBook && !isAdmin(userDetails) && !getIsPremiumUser()) {
      // notification.info({
      //   // duration: 0,
      //   message: 'Please move to premium version to view the summary.',
      // });
      this.setState({
        showAuth: true,
      });
      return;
    }
    this.setState({
      visibleDrawer: true,
    });
  };

  callParentAuthClose = () => {
    this.setState({
      showAuth: false,
    });
  }

  regenerateChapImage = (type = 0) => {
    const { podcastEpisode } = this.props;
    regenerateChapImage(podcastEpisode.collectionId, podcastEpisode.pubDate, type)
      .then(() => {
        notification.success({
          duration: 0,
          message: 'Regenerated chap image ep' + podcastEpisode.pubDate,
        });
      }).catch(err => {
        notification.error({
          duration: 0,
          message: 'Regenerated chap image Failed ep ' + podcastEpisode.pubDate,
        });
      })
  }

  render() {
    const { podcastEpisode, podcastEpisodes, fromPlaylistId, playlistInfo, userDetails, parent, popularEpisodesMap, review,
      itunesImage, audioInfo, showSeparator, isCard, isBasic, showProgressBar,
      isArticlePage, showDescription, customTextAtTop, playlistId, rawTokenCount, itunesData } = this.props;
    const { windowWidth, visibleDrawer, showAuth } = this.state;
    if (itunesImage) {
      podcastEpisode['artworkUrl600'] = itunesImage;
    }

    if (!podcastEpisode || !podcastEpisode.title) {
      return null;
    }

    // let isCardFin = windowWidth < 767 ? true : isCard;
    const isMobile = windowWidth < 767;
    let isCardFin = isCard;

    const currentlyPlaying = (audioInfo && audioInfo.guid == podcastEpisode.guid); // || (currentEpisodeId == podcastEpisode.guid);
    const { podcastEpBgColor, borderColor } = this.props.settingsState;
    const activeEpisodeBgColor = (currentlyPlaying || isArticlePage) ? podcastEpBgColor : 'inherit';

    // const { personalValues } = this.props;
    // const currentlyPlaying = (audioInfo && audioInfo.guid == podcastEpisode.guid) || (currentEpisodeId == podcastEpisode.guid);

    // const itunesCollectionId = podcastEpisode.collectionId;
    let imgSrc = getFinalEpisodeImg(podcastEpisode, parent, 'sm');
    // if (!this.state.noImageLoadError) { // in case of http img error
    //   imgSrc = getPodcastImgSize(podcastEpisode && podcastEpisode['artworkUrl600'], 'sm');
    // } else {
    // if (parent !== 'podcast') {
    //   imgSrc = getPodcastImgSize(podcastEpisode['artworkUrl600'], 'sm') || getPodcastImgSize(podcastEpisode.thumbnail, 'sm') || '';
    //   // console.dir(podcastEpisode);
    //   // console.log('imgSrc : ' + imgSrc);
    // } else {
    //   imgSrc = typeof podcastEpisode.thumbnail !== 'undefined' && podcastEpisode.thumbnail.length > 0 ? podcastEpisode.thumbnail :
    //     getPodcastImgSize(podcastEpisode['artworkUrl600'], 'sm');
    //   // typeof podcastEpisodes !== 'undefined' && typeof podcastEpisodes.feed !== 'undefined' && podcastEpisodes.feed.image !== 'undefined' ? podcastEpisodes.feed.image : '';
    // }
    // }
    // console.dir(podcastEpisodes);
    // const imgSrc = typeof podcastEpisode.thumbnail !== 'undefined' && podcastEpisode.thumbnail.length > 0 ? podcastEpisode.thumbnail : '';
    const pubDate = podcastEpisode.pubDate;

    const appEpisodeNumber = podcastEpisode && podcastEpisode.appEpisodeNumber;

    // const onImageLoadError = (e) => {
    //   console.dir('in event 1');
    //   if (this.state.noImageLoadError) {
    //     this.setState({
    //       noImageLoadError: false
    //     });
    //     console.dir('in event');
    //     // e.target.src = getPodcastImgSize(podcastEpisode && podcastEpisode['artworkUrl600'], 'sm'); // 'fallbackImage.png';
    //   }
    // }
    // console.dir(itunesData);

    const isSearch = parent === 'search-all';

    const episodeUUID = isBasic ? podcastEpisode.guid : getUUID(podcastEpisode.guid);
    let episodeLinkHref = `/episode?uuid=${episodeUUID}`;
    let episodeLinkAs = `/episode/${episodeUUID}`;

    let cleanedGenres = cleanGenres(podcastEpisode.genres);
    let genres = cleanedGenres.join(', ');
    console.dir(podcastEpisode);
    const showImage = podcastEpisode.thumbnail;
    const isUserAdmin = isAdmin(userDetails);

    return (
      <div className='podcast-item' style={{ marginRight: isCardFin && (isBasic ? '0em' : '2em'), marginBottom: isCardFin && '2em' }}>
        {visibleDrawer &&
          <EpisodeDrawer podcastEpisode={podcastEpisode} userDetails={userDetails} podcastEpisodes={podcastEpisodes}
            itunesData={itunesData}
            rawTokenCount={rawTokenCount} onDrawerClose={this.onDrawerClose} />
        }
        {showAuth && <SignUp key='signUp' typeId='signUp' isAds={false} autoShowAuth={true} callParent={this.callParentAuthClose} />}
        <Row className='episode-list-item' style={{
          width: isCardFin && (isBasic ? '260px' : '280px'),
          backgroundColor: `${activeEpisodeBgColor}`, borderRadius: `${spacing()}`
        }}>
          <Col span={!isCardFin ? 2 : 0}>
            <div className="image-container">
              {/* <img src={imgSrc} onError={onImageLoadError} /> */}
              {/* <img src={imgSrc} onError={onImageLoadError} /> */}
              {/* <object style={{ maxHeight: '120px' }} data={imgSrc} type="image/png">
                <img src={getPodcastImgSize(podcastEpisode['artworkUrl600'], 'sm')} alt="podcast image" />
              </object> */}
              {/* <AppCustomLink as={episodeLinkAs}
                href={episodeLinkHref}>
                <a onMouseDown={this.saveEpisodeLocally.bind(this, podcastEpisode)} rel="nofollow">
                  <PodcastEpisodeImage imgSrc={imgSrc} podcastEpisode={podcastEpisode} />
                </a>
              </AppCustomLink> */}

              {appEpisodeNumber && appEpisodeNumber > 0 && <h5 style={{ textAlign: 'center', marginTop: `0.25em` }}>&#x23;{appEpisodeNumber}</h5>}
            </div>
          </Col>
          {isSearch ? <Col span={1}>&nbsp;</Col> :
            (isAdmin(userDetails) ?
              <Col span={!isCardFin ? 1 : 0} style={{ textAlign: 'left' }}>
                <PlayMain podcastEpisode={podcastEpisode} episodesToPlay={podcastEpisodes} playlistId={playlistId} iconType='twoTone' />
                <br />
                {userDetails && userDetails.uid == nanooUID && <div>
                  <a href={podcastEpisode.enclosure.link} target='_blank' rel='noreferrer noopener' download='true'>
                    <FontAwesomeIcon style={{ marginTop: `${spacing()}`, marginLeft: `calc(0.9*${spacing('xs')})` }} icon='download' /></a>
                </div>}
              </Col> : <></>)
          }
          <Col span={!isCardFin ? (isMobile ? 18 : 15) : 24} style={{ paddingLeft: 0 }}>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Col span={isCardFin ? 10 : 0} style={{ marginBottom: `${spacing()}` }}>
                <div className="image-container">
                  <AppCustomLink as={episodeLinkAs}
                    href={episodeLinkHref}>
                    <a onMouseDown={this.saveEpisodeLocally.bind(this, podcastEpisode)} rel="nofollow">
                      {/* <Img style={{ maxHeight: '120px', cursor: 'pointer', maxWidth: `${isBasic && '160px'}` }}
                        src={[imgSrc, getPodcastImgSize(podcastEpisode['artworkUrl600'], 'sm')]}
                        alt={`Image of ${podcastEpisode.title || ''} podcast episode`}
                        loader={<div className='load-image'></div>}
                        unloader={<div className='load-image'></div>} /> */}
                      {/* <PodcastEpisodeImage imgSrc={imgSrc} podcastEpisode={podcastEpisode} /> */}
                    </a>
                  </AppCustomLink>
                </div>
              </Col>
              {/* {!isSearch && <Col span={isCardFin ? 4 : 0} style={{ textAlign: 'left' }}>
                {!isBasic && <PlayMain podcastEpisode={podcastEpisode} episodesToPlay={podcastEpisodes} playlistId={playlistId} iconType='twoTone' />}
              </Col>} */}
              {!isSearch && <Col span={isCardFin ? 4 : 0}>
                {!isBasic && (!review || isMyReview(userDetails, review)) && <RatingModal parent={parent} podcastEpisode={podcastEpisode} />}
              </Col>}
              {/* {!isSearch && !isArticlePage && <Col span={isCardFin ? 5 : 0} style={{ textAlign: 'center' }}>
                <PodcastEpisodeOptions podcastEpisode={podcastEpisode} fromPlaylistId={fromPlaylistId} isBasic={isBasic} parent={parent} review={review} />
              </Col>} */}
            </Row>

            <h2 className='episode-title' style={{ minHeight: isCardFin && '42px' }} onMouseDown={this.saveEpisodeLocally.bind(this, podcastEpisode)}>
              {podcastEpisode.title.length > 160 ? cleanText(podcastEpisode.title.substring(0, 160)).concat('...') :
                cleanTitleText(podcastEpisode.title)}
            </h2>
            {(isUserAdmin) &&
              <>
                <ChapterImage collectionId={podcastEpisode.collectionId}
                  width={isUserAdmin ? '600px' : '400px'}
                  thumbnail={podcastEpisode.thumbnail || ''} />
                <div>
                  <Button onClick={this.regenerateChapImage.bind(this)}>Regenerate</Button>
                  <Button onClick={this.regenerateChapImage.bind(this, 3)}>Converge Lens</Button>
                  <Button onClick={this.regenerateChapImage.bind(this, 2)}>Regenerate as Bulb</Button>
                  <Button onClick={this.regenerateChapImage.bind(this, 1)}> as DNA</Button>
                </div>
              </>
            }

            {customTextAtTop && <h5><span style={{ color: 'green' }}>{customTextAtTop}</span></h5>}
            {/* </Col>
          <Col span={8}> */}
            {/* {showDescription && !isBasic && <div className="image-container-markup" style={{ minHeight: '50px' }}>
              <ExpandCollapse isCard={isCardFin} textInfo={podcastEpisode && podcastEpisode.description || 'No Description'}
                parent='episode' />
            </div>} */}
            {/* {isAdmin(userDetails) && <p dangerouslySetInnerHTML={{ __html: (podcastEpisode.description || '').replaceAll('\n\n', '<br /><br />') }}>
            </p>} */}
            {/* {isSearch && <p className='genres' style={{ fontSize: '12px', textAlign: 'left' }}>{genres}</p>}
            {parent == 'podcast' && <ShowPopular podcastEpisode={podcastEpisode} popularEpisodesMap={popularEpisodesMap} />} */}
            <Row style={{ marginTop: `${spacing('xs')}`, fontSize: '0.9em' }}>

              {!isBasic && <Col span={isCardFin ? 12 : 0} style={{ textAlign: 'right' }}>
                <p>{secToTime(podcastEpisode.enclosure && podcastEpisode.enclosure.duration || 0, false, false)}</p>
              </Col>}
            </Row>

            {!isBasic && <Row>
              <Col span={isCardFin ? 24 : 0} style={{ textAlign: 'center' }}>
                <EpisodeProgressBar podcastEpisode={podcastEpisode} />
              </Col>
            </Row>}
          </Col>
          {(showProgressBar && parent != QUEUE && !isMobile) && <Col span={!isCardFin ? 3 : 0} style={{ marginTop: '10px' }}>
            <EpisodeProgressBar podcastEpisode={podcastEpisode} />
          </Col>}
          {!isBasic && <Col span={!isCardFin ? 2 : 0} offset={isMobile ? 1 : 0}
            style={{ textAlign: 'right', paddingRight: `${spacing('xs')}`, height: '40px' }}>
            {/* {isAdmin(userDetails) && <p>{(podcastEpisode.description || '').split(' ').length} words</p>} */}
            <p>{secToTime(podcastEpisode.enclosure && podcastEpisode.enclosure.duration || 0, false, false)}</p>
            {/* {podcastEpisode.enclosure.duration} */}
          </Col>}
          {/* <Col span={parent == QUEUE ? 5 : (!isCardFin ? (showProgressBar ? 3 : 4) : 0)} style={{ textAlign: 'center', height: '40px' }}>

          </Col> */}
          {!isBasic && !isSearch && !isMobile && (!review || isMyReview(userDetails, review)) && <Col span={!isCardFin ? 1 : 0} style={{ textAlign: 'right', marginTop: '-2px', height: '40px' }}>
            {/* <Tooltip title="Your rating"> */}
            <RatingModal parent={parent} podcastEpisode={podcastEpisode} />
            {/* </Tooltip> */}
          </Col>}
          {/* {!isSearch && !isArticlePage && <Col className='episode-options-app' span={!isCardFin ? 1 : 0} style={{ textAlign: 'right', height: '40px' }}>
            <PodcastEpisodeOptions podcastEpisode={podcastEpisode} fromPlaylistId={fromPlaylistId} isBasic={isBasic} parent={parent} review={review} />
          </Col>} */}
        </Row>
        {/* {playlistInfo && playlistInfo.collaborative && podcastEpisode.username &&
          <div style={{ 'position': 'absolute', right: '1em', bottom: '2em' }}>
            <ProfilePageRoute profileUID={podcastEpisode.userUID}>Added by {podcastEpisode.username || '-'} {podcastEpisode.userUID == (userDetails && userDetails.uid || '--') && ' (You)'}
            </ProfilePageRoute></div>
        } */}
        {(isArticlePage || parent == QUEUE) && !isCardFin && <EpisodeProgressBar podcastEpisode={podcastEpisode} />}
        {(showSeparator && parent != QUEUE) && <hr className='separator' />}

        <style jsx>
          {`
            .episode-title{
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;  
              overflow: hidden;
              font-family: 'Didact Gothic', sans-serif;
              font-size: 14px;
            }
            .episode-title:hover {
              text-decoration: underline;
              cursor: pointer;
            }
           .podcast-item {
              // background: ${activeEpisodeBgColor};
              border-radius: 1em;
              // padding: ${fixedSpacing('sm')} ${fixedSpacing('sm')};
              padding: ${fixedSpacing('xxs')} ${isMobile ? 0 : fixedSpacing('xs')};
              position: relative;
           }
          //  .podcast-item:hover {
          //     background: ${podcastEpBgColor};
          //  }
           :global(.episode-list-item) {
              padding: 0.75em ${isMobile ? 0 : fixedSpacing('xs')};
              // padding-bottom: ${fixedSpacing('xxs')};
           }
           .podcast-item Col {
            text-align: center;
           }
           h4 {
            padding-right: ${spacing()};
           }
           .image-container {
              width:4.5em;
              // min-height: 60px;
              max-width: 100%;
            }
           :global(.image-container img), .load-image {
            // image-rendering: -moz-crisp-edges;
            image-rendering: -o-crisp-edges;
            // image-rendering: -webkit-optimize-contrast;
            // image-rendering: auto; // crisp-edges;
            // -ms-interpolation-mode: nearest-neighbor;
            max-width:100%;
            max-height:100%;
            min-height: 56px;
            border-radius: ${spacing('xs')};
            // border: 1px solid ${borderColor};
            // box-shadow: 0 4px 4px rgba(0,0,0,0.30), 0 2px 2px rgba(0,0,0,0.22);
            box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
          }
          .load-image {
            background-color: ${rightSideBarColor};
          }
          @media ${maxScreenSize.tablet} {
            :global(.episode-options-app) {
              transform: translate(0, -8vh);
            }
          }
          @media ${maxScreenSize.laptop} {
            .image-container {
              width: ${spacing('xl')};
            }
            :global(.image-container img), .load-image {
              min-height: ${spacing('xl')};
            }
          }
          :global(.image-container-markup img) {
            max-width:150px;
            max-height:150px;
          }
          :global(.image-container-markup p) {
            margin-bottom: 0;
          }
          :global(.ant-slider-handle) {
            display: none;
          }
          `}
        </style>
      </div >
    );
  }
}

PodcastEpisode.defaultProps = {
  showSeparator: true,
  isCard: false,
  isBasic: false,
  showProgressBar: true,
  isArticlePage: false,
  showDescription: true,
  customTextAtTop: ''
}

PodcastEpisode.propTypes = {
  podcastEpisode: PropTypes.object,
  podcastEpisodes: PropTypes.array,
  userDetails: PropTypes.object,
  // userPlaylists: PropTypes.object,
  fromPlaylistId: PropTypes.string,
  itunesImage: PropTypes.string,
  parent: PropTypes.string,
  audioInfo: PropTypes.object,
  review: PropTypes.object,
  playAudio: PropTypes.object,
  currentEpisodeId: PropTypes.object,
  rawTokenCount: PropTypes.object,
  isCard: PropTypes.bool,
  isBasic: PropTypes.bool,
  // addToPlaylist: PropTypes.func,
  deleteFromHistoryProgress: PropTypes.func,
  deleteFromHistory: PropTypes.func,
  deleteFromPlaylist: PropTypes.func,
  deleteReview: PropTypes.func,
  settingsState: PropTypes.object,
  playlistInfo: PropTypes.object,
  popularEpisodesMap: PropTypes.object,
  itunesData: PropTypes.object,
  showSeparator: PropTypes.bool,
  showProgressBar: PropTypes.bool,
  isArticlePage: PropTypes.bool,
  showDescription: PropTypes.bool,
  customTextAtTop: PropTypes.string,
  playlistId: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    // userPlaylists: state.userPlaylists,
    settingsState: state.settingsState,
    audioInfo: state.audioState || {},
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteFromHistoryProgress: bindActionCreators(deleteFromHistoryProgress, dispatch),
    deleteFromHistory: bindActionCreators(deleteFromHistory, dispatch),
    // addToPlaylist: bindActionCreators(addToPlaylist, dispatch),
    deleteFromPlaylist: bindActionCreators(deleteFromPlaylist, dispatch),
    deleteReview: bindActionCreators(deleteReview, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastEpisode)